export function getEnumName<T>(enumType: Record<string, unknown>, value: T): string {
    let result = ""
    Object.keys(enumType).forEach((key) => {
        if (enumType[key] == value) {
            result = key
        }
    })
    return result
}
